import { Action } from '@ngrx/store';
import {
  ManagerCustomerUser,
  CustomerManagerCompany,
  ManagerCustomerMeteringPoint,
  ManagerJobLockStatus
} from '@model';

export enum ManagerCustomersActionTypes {
  ManagerCustomerSelect = '[ManagerCustomer] Select',
  ManagerCustomersSelection = '[ManagerCustomer] Set Customers Selection',

  ManagerCustomerUsersLoadData = '[ManagerCustomerUsers] Load data',
  ManagerCustomerUsersLoadSuccess = '[ManagerCustomerUsers] Load success',
  ManagerCustomerUsersLoadFail = '[ManagerCustomerUsers] Load fail',

  ManagerCustomersUsersLoadData = '[ManagerCustomersUsers] Load data',
  ManagerCustomersUsersLoadSuccess = '[ManagerCustomersUsers] Load success',
  ManagerCustomersUsersLoadFail = '[ManagerCustomersUsers] Load fail',

  ManagerCustomerMeteringPointsLoad = '[ManagerCustomerMeteringPoints] Load data',
  ManagerCustomerMeteringPointsLoadSuccess = '[ManagerCustomerMeteringPoints] Load success',
  ManagerCustomerMeteringPointsLoadFail = '[ManagerCustomerMeteringPoints] Load fail',

  BulkAddManagerUsersToCustomer = '[ManagerCompanyUserToCustomer] Bulk add',
  BulkAddManagerUsersToCustomerSuccess = '[ManagerCompanyUserToCustomer] Bulk add success',
  BulkAddManagerUsersToCustomerFail = '[ManagerCompanyUserToCustomer] Bulk add fail',

  ManagerCustomerUserSelect = '[ManagerCustomerUser] Select',

  UpdateManagerCustomerUser = '[ManagerCustomerUser] Update',
  UpdateManagerCustomerUserSuccess = '[ManagerCustomerUser] Update success',
  UpdateManagerCustomerUserFail = '[ManagerCustomerUser] Update fail',

  ManagerCustomerUserRemove = '[ManagerCustomerUser] Remove',
  ManagerCustomerUserRemoveSuccess = '[ManagerCustomerUser] Remove success',
  ManagerCustomerUserRemoveFail = '[ManagerCustomerUser] Remove fail',

  ManagerCustomerRemove = '[ManagerCustomer] Remove',
  ManagerCustomerRemoveSuccess = '[ManagerCustomer] Remove success',
  ManagerCustomerRemoveFail = '[ManagerCustomer] Remove fail',

  LockManagerCustomerUsersForUpdate = '[ManagerCustomerUser] lock for update',
  LockManagerCustomerUsersForUpdateSuccess = '[ManagerCustomerUser] lock for update success',
  LockManagerCustomerUsersForUpdateFail = '[ManagerCustomerUser] lock for update fail'

 
}

export class ManagerCustomerSelect implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomerSelect;
  constructor(public payload: CustomerManagerCompany) {}
}

export class ManagerCustomerUsersLoadData implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomerUsersLoadData;
  constructor(public payload: { managerCompanyId: number; customerId: string }) {}
}

export class ManagerCustomerUsersLoadSuccess implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomerUsersLoadSuccess;
  constructor(public payload: ManagerCustomerUser[]) {}
}

export class ManagerCustomerUsersLoadFail implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomerUsersLoadFail;
  constructor(public payload: any) {}
}

export class ManagerCustomerMeteringPointsLoad implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomerMeteringPointsLoad;
  constructor(public payload: CustomerManagerCompany) {}
}

export class ManagerCustomerMeteringPointsLoadSuccess implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomerMeteringPointsLoadSuccess;
  constructor(public payload: ManagerCustomerMeteringPoint[]) {}
}

export class ManagerCustomerMeteringPointsLoadFail implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomerMeteringPointsLoadFail;
  constructor(public payload: any) {}
}

export class ManagerCustomerUserSelect implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomerUserSelect;
  constructor(public payload: ManagerCustomerUser) {}
}

export class UpdateManagerCustomerUser implements Action {
  readonly type = ManagerCustomersActionTypes.UpdateManagerCustomerUser;
  constructor(public payload: ManagerCustomerUser) {}
}
export class UpdateManagerCustomerUserSuccess implements Action {
  readonly type = ManagerCustomersActionTypes.UpdateManagerCustomerUserSuccess;
  constructor(public payload: ManagerCustomerUser) {}
}
export class UpdateManagerCustomerUserFail implements Action {
  readonly type = ManagerCustomersActionTypes.UpdateManagerCustomerUserFail;
  constructor(public payload: any) {}
}
export class ManagerCustomerUserRemove implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomerUserRemove;
  constructor(public payload: ManagerCustomerUser) {}
}
export class ManagerCustomerUserRemoveSuccess implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomerUserRemoveSuccess;
  constructor(public payload: ManagerCustomerUser) {}
}
export class ManagerCustomerUserRemoveFail implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomerUserRemoveFail;
  constructor(public payload: any) {}
}

export class ManagerCustomerRemove implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomerRemove;
  constructor(public payload: CustomerManagerCompany) {}
}
export class ManagerCustomerRemoveSuccess implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomerRemoveSuccess;
  constructor(public payload: CustomerManagerCompany) {}
}
export class ManagerCustomerRemoveFail implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomerRemoveFail;
  constructor(public payload: any) {}
}

export class BulkAddManagerUsersToCustomer implements Action {
  readonly type = ManagerCustomersActionTypes.BulkAddManagerUsersToCustomer;
  constructor(public payload: ManagerCustomerUser[]) {}
}
export class BulkAddManagerUsersToCustomerSuccess implements Action {
  readonly type = ManagerCustomersActionTypes.BulkAddManagerUsersToCustomerSuccess;
  constructor(public payload: ManagerCustomerUser[]) {}
}
export class BulkAddManagerUsersToCustomerFail implements Action {
  readonly type = ManagerCustomersActionTypes.BulkAddManagerUsersToCustomerFail;
  constructor(public payload: any) {}
}
export class LockManagerCustomerUsersForUpdate implements Action {
  readonly type = ManagerCustomersActionTypes.LockManagerCustomerUsersForUpdate;
  constructor(public payload: ManagerCustomerUser[]) {}
}
export class LockManagerCustomerUsersForUpdateSuccess implements Action {
  readonly type = ManagerCustomersActionTypes.LockManagerCustomerUsersForUpdateSuccess;
  constructor(public payload: ManagerJobLockStatus) {}
}
export class LockManagerCustomerUsersForUpdateFail implements Action {
  readonly type = ManagerCustomersActionTypes.LockManagerCustomerUsersForUpdateFail;
  constructor(public payload: any) {}
}

export class ManagerCustomersSelection implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomersSelection;
  constructor(public payload: string[]) {}
}

export class ManagerCustomersUsersLoadData implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomersUsersLoadData;
  constructor(public payload: { managerCompanyId: number; customerIds: string[] }) {}
}
export class ManagerCustomersUsersLoadSuccess implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomersUsersLoadSuccess;
  constructor(public payload: ManagerCustomerUser[]) {}
}
export class ManagerCustomersUsersLoadFail implements Action {
  readonly type = ManagerCustomersActionTypes.ManagerCustomersUsersLoadFail;
  constructor(public payload: any) {}
}

export type ManagerCustomersActions =
  | ManagerCustomerSelect
  | ManagerCustomersSelection
  | ManagerCustomerUsersLoadData
  | ManagerCustomerUsersLoadSuccess
  | ManagerCustomerUsersLoadFail
  | ManagerCustomersUsersLoadData
  | ManagerCustomersUsersLoadSuccess
  | ManagerCustomersUsersLoadFail
  | ManagerCustomerMeteringPointsLoad
  | ManagerCustomerMeteringPointsLoadSuccess
  | ManagerCustomerMeteringPointsLoadFail
  | ManagerCustomerUserSelect
  | UpdateManagerCustomerUser
  | UpdateManagerCustomerUserSuccess
  | UpdateManagerCustomerUserFail
  | ManagerCustomerUserRemove
  | ManagerCustomerUserRemoveSuccess
  | ManagerCustomerUserRemoveFail
  | ManagerCustomerRemove
  | ManagerCustomerRemoveSuccess
  | ManagerCustomerRemoveFail
  | BulkAddManagerUsersToCustomer
  | BulkAddManagerUsersToCustomerSuccess
  | BulkAddManagerUsersToCustomerFail
  | LockManagerCustomerUsersForUpdate
  | LockManagerCustomerUsersForUpdateSuccess
  | LockManagerCustomerUsersForUpdateFail;
